module.exports = __webpack_public_path__ + "public/images/visual-art.c2cad7420abe534f665d18388d065b89.png";